import { XeroAccount } from './xero-account.model';
import { IDispatchId, IRequestError } from '../../utils/helpers/redux.helper';

export enum ActionsEnum {
  FETCH_XERO_ACCOUNT = 'FETCH_XERO_ACCOUNT',
  FETCH_XERO_ACCOUNT_SUCCESS = 'FETCH_XERO_ACCOUNT_SUCCESS',
  FETCH_XERO_ACCOUNT_ERROR = 'FETCH_XERO_ACCOUNT_ERROR',
  AUTHORIZE_ACCOUNT = 'AUTHORIZE_ACCOUNT',
  AUTHORIZE_ACCOUNT_SUCCESS = 'AUTHORIZE_ACCOUNT_SUCCESS',
  AUTHORIZE_ACCOUNT_ERROR = 'AUTHORIZE_ACCOUNT_ERROR',
  UPDATE_XERO_ACCOUNT = 'UPDATE_XERO_ACCOUNT',
  EXPORT_DOCUMENT_TO_XERO = 'EXPORT_DOCUMENT_TO_XERO',
  EXPORT_DOCUMENT_TO_XERO_SUCCESS = 'EXPORT_DOCUMENT_TO_XERO_SUCCESS',
  EXPORT_DOCUMENT_TO_XERO_ERROR = 'EXPORT_DOCUMENT_TO_XERO_ERROR',
  DELETE_XERO_ACCOUNT = 'DELETE_XERO_ACCOUNT',
  DELETE_XERO_ACCOUNT_SUCCESS = 'DELETE_XERO_ACCOUNT_SUCCESS',
  DELETE_XERO_ACCOUNT_ERROR = 'DELETE_XERO_ACCOUNT_ERROR',
  UPDATE_XERO_ACCOUNT_NETWORK = 'UPDATE_XERO_ACCOUNT_NETWORK',
  UPDATE_XERO_ACCOUNT_NETWORK_SUCCESS = 'UPDATE_XERO_ACCOUNT_NETWORK_SUCCESS',
  UPDATE_XERO_ACCOUNT_NETWORK_ERROR = 'UPDATE_XERO_ACCOUNT_NETWORK_ERROR',
  RESET_UPDATE_XERO_ERROR = 'RESET_UPDATE_XERO_ERROR',
}

// action payloads
export interface IXeroAccount {
  xeroAccount: XeroAccount;
}

export interface IXeroDocumentExport extends IDispatchId {
  documentId: string;
  documentNumber: string;
}

export interface IXeroDocumentExportError extends IDispatchId {
  documentNumber: string;
  error: any[];
}

export interface IUpdateXeroAccountNetwork extends IDispatchId {
  autoExport: boolean;
  defaultAccountCode: string;
  country: string;
  i2gCurrency: string;
}

export interface IAuthorizeAccountSuccess extends IDispatchId {
  xeroAuthUrl: string;
}

// action definitions
export interface FetchXeroAccount {
  type: ActionsEnum.FETCH_XERO_ACCOUNT;
  payload: IDispatchId;
}

export interface FetchXeroAccountSuccess {
  type: ActionsEnum.FETCH_XERO_ACCOUNT_SUCCESS;
  payload: IDispatchId;
}

export interface FetchXeroAccountError {
  type: ActionsEnum.FETCH_XERO_ACCOUNT_ERROR;
  payload: IRequestError;
}

export interface AuthorizeAccount {
  type: ActionsEnum.AUTHORIZE_ACCOUNT;
  payload: IDispatchId;
}

export interface AuthorizeAccountSuccess {
  type: ActionsEnum.AUTHORIZE_ACCOUNT_SUCCESS;
  payload: IAuthorizeAccountSuccess;
}

export interface AuthorizeAccountError {
  type: ActionsEnum.AUTHORIZE_ACCOUNT_ERROR;
  payload: IRequestError;
}

export interface UpdateXeroAccount {
  type: ActionsEnum.UPDATE_XERO_ACCOUNT;
  payload: IXeroAccount;
}

export interface UpdateXeroAccountNetwork {
  type: ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK;
  payload: IUpdateXeroAccountNetwork;
}

export interface UpdateXeroAccountNetworkSuccess {
  type: ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_SUCCESS;
  payload: IDispatchId;
}

export interface UpdateXeroAccountNetworkError {
  type: ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_ERROR;
  payload: IRequestError;
}

export interface ExportDocumentToXero {
  type: ActionsEnum.EXPORT_DOCUMENT_TO_XERO;
  payload: IXeroDocumentExport;
}

export interface ExportDocumentToXeroSuccess {
  type: ActionsEnum.EXPORT_DOCUMENT_TO_XERO_SUCCESS;
  payload: IXeroDocumentExport;
}

export interface ExportDocumentToXeroError {
  type: ActionsEnum.EXPORT_DOCUMENT_TO_XERO_ERROR;
  payload: IXeroDocumentExportError;
}

export interface DeleteXeroAccount {
  type: ActionsEnum.DELETE_XERO_ACCOUNT;
  payload: IDispatchId;
}

export interface DeleteXeroAccountSuccess {
  type: ActionsEnum.DELETE_XERO_ACCOUNT_SUCCESS;
  payload: IDispatchId;
}

export interface DeleteXeroAccountError {
  type: ActionsEnum.DELETE_XERO_ACCOUNT_ERROR;
  payload: IRequestError;
}

export interface ResetUpdateXeroError {
  type: ActionsEnum.RESET_UPDATE_XERO_ERROR;
}

// action creators
export const fetchXeroAccount = (dispatchId: string): FetchXeroAccount => ({
  type: ActionsEnum.FETCH_XERO_ACCOUNT,
  payload: {
    dispatchId,
  },
});

export const fetchXeroAccountSuccess = (
  dispatchId: string
): FetchXeroAccountSuccess => ({
  type: ActionsEnum.FETCH_XERO_ACCOUNT_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const fetchXeroAccountError = (
  dispatchId: string,
  error: Error
): FetchXeroAccountError => ({
  type: ActionsEnum.FETCH_XERO_ACCOUNT_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const authorizeAccount = (dispatchId: string): AuthorizeAccount => ({
  type: ActionsEnum.AUTHORIZE_ACCOUNT,
  payload: {
    dispatchId,
  },
});

export const authorizeAccountSuccess = (
  dispatchId: string,
  xeroAuthUrl: string
): AuthorizeAccountSuccess => ({
  type: ActionsEnum.AUTHORIZE_ACCOUNT_SUCCESS,
  payload: {
    dispatchId,
    xeroAuthUrl,
  },
});

export const authorizeAccountError = (
  dispatchId: string,
  error: Error
): AuthorizeAccountError => ({
  type: ActionsEnum.AUTHORIZE_ACCOUNT_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const updateXeroAccount = (
  xeroAccount: XeroAccount
): UpdateXeroAccount => ({
  type: ActionsEnum.UPDATE_XERO_ACCOUNT,
  payload: {
    xeroAccount,
  },
});

export const updateXeroAccountNetwork = (
  autoExport: boolean,
  defaultAccountCode: string,
  country: string,
  i2gCurrency: string,
  dispatchId: string
): UpdateXeroAccountNetwork => ({
  type: ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK,
  payload: {
    autoExport,
    defaultAccountCode,
    country,
    i2gCurrency,
    dispatchId,
  },
});

export const updateXeroAccountNetworkSuccess = (
  dispatchId: string
): UpdateXeroAccountNetworkSuccess => ({
  type: ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const updateXeroAccountNetworkError = (
  dispatchId: string,
  error: Error
): UpdateXeroAccountNetworkError => ({
  type: ActionsEnum.UPDATE_XERO_ACCOUNT_NETWORK_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const exportDocumentToXero = (
  dispatchId: string,
  documentId: string,
  documentNumber: string
): ExportDocumentToXero => ({
  type: ActionsEnum.EXPORT_DOCUMENT_TO_XERO,
  payload: {
    dispatchId,
    documentId,
    documentNumber,
  },
});

export const exportDocumentToXeroSuccess = (
  dispatchId: string,
  documentId: string,
  documentNumber: string
): ExportDocumentToXeroSuccess => ({
  type: ActionsEnum.EXPORT_DOCUMENT_TO_XERO_SUCCESS,
  payload: {
    dispatchId,
    documentId,
    documentNumber,
  },
});

export const exportDocumentToXeroError = (
  dispatchId: string,
  documentNumber: string,
  error: any[]
): ExportDocumentToXeroError => ({
  type: ActionsEnum.EXPORT_DOCUMENT_TO_XERO_ERROR,
  payload: {
    dispatchId,
    documentNumber,
    error,
  },
});

export const deleteXeroAccount = (dispatchId: string): DeleteXeroAccount => ({
  type: ActionsEnum.DELETE_XERO_ACCOUNT,
  payload: {
    dispatchId,
  },
});

export const deleteXeroAccountSuccess = (
  dispatchId: string
): DeleteXeroAccountSuccess => ({
  type: ActionsEnum.DELETE_XERO_ACCOUNT_SUCCESS,
  payload: {
    dispatchId,
  },
});

export const deleteXeroAccountError = (
  dispatchId: string,
  error: Error
): DeleteXeroAccountError => ({
  type: ActionsEnum.DELETE_XERO_ACCOUNT_ERROR,
  payload: {
    dispatchId,
    error,
  },
});

export const resetUpdateXeroError = (): ResetUpdateXeroError => ({
  type: ActionsEnum.RESET_UPDATE_XERO_ERROR,
});
